import { trackEvent } from "@/utils/omega";
/**
 * 通过 Bridge 获取 wsgenv，用于特定接口（如 updateLimit）
 * @param url 完整接口地址（从 http/https 开始）
 */

export const getWsgenvByBridge = (url: string): Promise<string> => {
  return new Promise((resolve) => {
    try {
      if (window.Fusion && window.Fusion.WSGHybridModule && window.Fusion.WSGHybridModule.collect) {
        window.Fusion.WSGHybridModule.collect(
          {
            url,
            wsgbizsource: 'sofi',
          },
          (res: any) => {
            resolve(res.wsgenv || '')
          }
        )
      } else {
        trackEvent("tech_sofi_catch_error", {
          source: "utils.request.wsgenv.bridge",
          data: JSON.stringify('not find WSGHybridModule'),
        });
        resolve('')
      }
    } catch (err) {
      trackEvent("tech_sofi_catch_error", {
        source: "utils.request.wsgenv.bridge",
        data: JSON.stringify(err||'WSGHybridModule cllect error'),
      });
      resolve('')
    }
  })
}
